// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
(function() {
    // This checks whether #top_banner is visible so the background image and be lowered with the rest of the content
    var visible_top_banner = function(){
        if ($("#top_banner").is(':visible')) {
            $('body').css({"background-position" : "0px 40px"});
        }
    };

    $(document).ready(function() {
        visible_top_banner();
    });
})();
